let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gmc0h")).then(() => parcelRequire('bYKXe'));